import useMomentsUploadForm from './useMomentsUploadForm';

const useCustomersUploadForm = props => {
  const {
    onUploadStart,
    onUploadComplete,
    job
  } = props;

  return useMomentsUploadForm({
    onUploadStart,
    onUploadComplete,
    job,
    customersOnly: true
  });
}

export default useCustomersUploadForm;
